export default [
    {
        type: "lathe",
        segments: 10,
        vertices: [
            0.000001, 0.23, 0.042, 0.23, 0.069, 0.36, 0.038, 0.362, 0.038, 0.372, 0.06, 0.372, 0.073, 0.572, 0.024,
            0.572, 0.024, 0.67, 0.069, 0.67, 0.075, 0.722, 0.097, 0.724, 0.105, 0.852, 0.083, 0.902, 0.065, 0.902,
            0.065, 0.924, 0.128, 0.924, 0.146, 0.996,
        ],
    },
    {
        type: "lathe",
        segments: 16,
        vertices: [
            0.000001, 0.232, 0.229, 0.182, 0.486, 0.07, 0.356, 0.182, 0.213, 0.242, 0.154, 0.242, 0.144, 0.262, 0.178,
            0.262, 0.126, 0.314, 0.04, 0.328, 0.038, 0.374, 0.058, 0.374, 0.071, 0.408, 0.026, 0.406, 0.03, 0.42, 0.091,
            0.418, 0.034, 0.496, 0.01, 0.498, 0.03, 0.506, 0.014, 0.998,
        ],
    },
];
